// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__A2CvH","job_title":"style_job_title__iNZ3w","date":"style_date__c3MLq","status":"style_status__IEeQE","resume_btn":"style_resume_btn__wXNvR"};